import type { ShigoDashboardContext } from '../../../../auth/dashboardDestination';
import type { useNetworkFeatures } from '../../../../auth/useNetworkFeatures';
import { dashboardT } from '../../../../../lib/messages';
import type { ReportExplorerConfiguration } from '../../model';
import type { ReportMetric } from '../../reportEnums';
import { buildChartReportRequest, buildTableReportRequest } from '../../reportRequest';
import { isReportMetricCompatible } from '../../compatibility';
import { metricSelectionSections } from '../../selectionSections';
import { ReportSelectionDialog } from '../ReportSelectionDialog';

export function renderChartMetricsDialog(
  config: ReportExplorerConfiguration,
  features: ReturnType<typeof useNetworkFeatures>['features'],
  dashboardContext: ShigoDashboardContext,
  setConfig: React.Dispatch<React.SetStateAction<ReportExplorerConfiguration>>,
  onClose: () => void,
) {
  return (
    <ReportSelectionDialog<ReportMetric>
      title={dashboardT('reportExplorer.selection.chartMetricsTitle')}
      description={dashboardT('reportExplorer.selection.metricsDescription')}
      searchPlaceholder={dashboardT('reportExplorer.selection.searchMetrics')}
      sections={metricSelectionSections(features, true, dashboardContext)}
      value={config.chartMetrics}
      isDisabled={(candidate, draft) =>
        !isReportMetricCompatible(
          candidate,
          draft.filter((item) => item !== candidate),
          buildChartReportRequest(config).dimensions,
          buildTableReportRequest(config).filters,
        )
      }
      onApply={(chartMetrics) => {
        setConfig((current) => ({ ...current, chartMetrics }));
        onClose();
      }}
      onClose={onClose}
    />
  );
}
